import script from "./operateLog.vue?vue&type=script&lang=ts&setup=true"
export * from "./operateLog.vue?vue&type=script&lang=ts&setup=true"

import "./operateLog.vue?vue&type=style&index=0&id=1a22c310&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a22c310"]])

export default __exports__